import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Toggle } from 'commonsComponents/toggle';
import { AmountInput } from 'commonsComponents/amountInput';
import classNames from 'classnames';

//@helpers
const { MAX_LIMIT_INPUT_AMOUNT } = require('constants/index');
const { FormattedText, getLanguage } = require('core/i18n').i18n;
const {
  DOUBLE,
  BOOLEAN,
  TOGGLE,
  INPUT,
} = require('constants/index');

require('./ProductController.scss');

class ProductController extends Component {
  constructor(props) {
    super(props);

    const toggleInput = props.controllers.filter(c => c.type === DOUBLE)[0];

    this.state = {
      toggleValue: props.isEnabled,
      toggleInput: toggleInput ? toggleInput.amount : 0,
      minAmount: toggleInput ? toggleInput.minAmount : 0,
      error: false
    };
  }

  componentDidUpdate(prevProps){
    // If user saves changes, we refresh inputs state
    if (prevProps.controllers !== this.props.controllers) {
      const toggleInput = this.props.controllers.filter(c => c.type === DOUBLE)[0];
      this.setState({
        toggleValue: this.props.isEnabled,
        toggleInput: toggleInput ? toggleInput.amount : 0,
        minAmount: toggleInput ? toggleInput.minAmount : 0,
        error: false
      });
    }
  }

  buildToggle = (id) => {
    const { toggleValue } = this.state;

    return (
      <Toggle
        checked={toggleValue}
        onClick={() => this.changeToggle(id)}
      />
    );
  }

  changeToggle = (id) => {
    const { callback } = this.props;
    const { toggleValue } = this.state;

    this.setState({
      toggleValue: !toggleValue,
    }, () => {
      callback(id, TOGGLE, !toggleValue);
    });
  }

  buildAmountInput = (index, id) => {
    const { toggleInput, minAmount, error } = this.state;
    const instructionsMessage = (minAmount > 0) && <FormattedText value="notificationManagement-minAmountHint" injectedStrings={[minAmount]} />;
    const errorMsg = <FormattedText value="notificationManagement-minAmountHintError" injectedStrings={[minAmount]} />;

    return (
      <div className="product-controller__amount-input">
        <AmountInput
          amount={toggleInput}
          key={index.toString()}
          callback={(newValue) => { this.changeAmount(newValue, id); }}
          fluid
          instructionsMessage={instructionsMessage}
          error={error}
          errorMsg={errorMsg}
          max={MAX_LIMIT_INPUT_AMOUNT}
          language={getLanguage()}
        />
      </div>
    );
  }

  changeAmount = (toggleInput, id) => {
    const { minAmount } = this.state;
    const { callback } = this.props;
    const newInputValue = toggleInput.toFixed(2);
    const isValidAmount = (newInputValue >= minAmount);

    this.setState({
      toggleInput: newInputValue,
      error: !isValidAmount
    }, () => {
      callback(id, INPUT, newInputValue);
    });
  }

  buildControllerType = () => {
    const { toggleValue } = this.state;
    const { controllers } = this.props;
    let typeControllerComponent;

    const typeController = controllers.sort((a, b) => a.type.localeCompare(b.type)).map((controller, index) => {
      switch (controller.type) {
        case DOUBLE:
          typeControllerComponent = toggleValue ? this.buildAmountInput(index, controller.id) : null;
          break;
        default:
          return null;
      }
      return typeControllerComponent;
    });

    return typeController;
  };

  buildDescriptionController = () => {
    const { toggleValue } = this.state;
    const { controllers, formatText } = this.props;

    const descriptionController = controllers
      .sort((a, b) => a.type.localeCompare(b.type))
      .map((controller, index) => {
        return (
          <Fragment>
            {controller.type === DOUBLE && toggleValue && (
            <p>
              {formatText(`notificationManagement-${controller.description}`)}
            </p>
            )}
          </Fragment>
        );
      });

    return descriptionController;
  };

  buildDescriptions = () => {
    const { formatText, description } = this.props;
    return (
      <Fragment>
        <p>{formatText(`notificationManagement-${description}`)}</p>
      </Fragment>
    );
  };

  render() {
    const { toggleValue } = this.state;
    const { controllers, idParent, title, formatText } = this.props;

    return (
      <div className="product-controller">
        <div className="row">
          <div className="col-xs-9 -no-padding">
            <div className="list-products__card__information"><p><b>{formatText(`notificationManagement-${title}`)}</b></p></div>
          </div>   
          <div className="col-xs-3">
            <div className="pull-right">{this.buildToggle(idParent)}</div>     
          </div>     
        </div>
        <div className="row">
          <div className="col-xs-9 -no-padding">
            <div className="product-controller__information">
              {this.buildDescriptions()}
              {this.buildDescriptionController()}
            </div>
          </div>
          <div className="col-xs-3">
            <div>{this.buildControllerType()}</div>
          </div>          
        </div>             
      </div>
    );
  }
}

ProductController.propTypes = {
  callback: PropTypes.func.isRequired,
  controllers: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  formatText: PropTypes.func.isRequired,
  idParent: PropTypes.string.isRequired,
  isEnabled: PropTypes.bool.isRequired,
};

export default ProductController;
